<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
       <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="user_info_top">
      <div class="user_info_top_left lf">
        <p class="lf">
          <img :src="detail.portrait" alt="用户头像">
        </p>
        <dl class="lf">
          <dt>
          {{detail.user_name}}
          <el-popover
            v-if="detail.is_enterprise === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台实名认证">
            <i class="my_icon_list shiming" slot="reference"></i>
          </el-popover>
          <el-popover
            v-if="detail.is_authentication === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台播主认证">
            <i class="my_icon_list bozhu" slot="reference"></i>
          </el-popover>
          <el-popover
            v-if="detail.is_lawyer === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台律师认证">
            <i class="my_icon_list lvshi" slot="reference"></i>
          </el-popover>
          <el-popover
            v-if="detail.is_personal === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台企业认证">
            <i class="my_icon_list qiye" slot="reference"></i>
          </el-popover>
          </dt>
          <dd>
            简介： {{detail.content}}
          </dd>
        </dl>
        <div class="user_info_top_btn">
          <button class="greenglga_btn" @click="edit()">
            <span>修改</span>
          </button>
        </div>
      </div>
      <div class="user_info_top_right lf">
        <p @click="jump('follow')">
          <i>{{detail.follow_count}}</i><br/>
          关注
        </p>
        <el-divider direction="vertical"></el-divider>
        <p @click="jump('fans')">
          <i>{{detail.fans_count}}</i><br/>
          粉丝
        </p>
        <el-divider direction="vertical"></el-divider>
        <p @click="jump('collection')">
          <i>{{detail.collection_count}}</i><br/>
          收藏
        </p>
      </div>
    </div>
    <div class="user_info_container">
      <personal-meun :slid="slidIndex"></personal-meun>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import meun from './personalMeun.vue'

export default {
  data () {
    return {
      detail: {},
      slidIndex: ''
    }
  },
  created () {
    this.getMyDetails()
  },
  components: {
    personalMeun: meun
  },
  methods: {
    getMyDetails () {
      const vueThat = this
      vueThat.myApi.getMyDetails().then((res) => {
        if (res.data.code === 200) {
          vueThat.detail = res.data.data.data
        }
      })
    },
    edit () {
      this.$store.commit('editPersonalMeunAct', 'personalData')
      this.$router.push({ path: '/personalData' })
    },
    jump (type) {
      switch (type) {
        case 'follow':
          this.$store.commit('editPersonalMeunAct', 'followList')
          this.$router.push({ path: '/followList' })
          break
        case 'fans':
          this.$store.commit('editPersonalMeunAct', 'fansList')
          this.$router.push({ path: '/fansList' })
          break
        case 'collection':
          this.$store.commit('editPersonalMeunAct', 'collect')
          this.$router.push({ path: '/collectList' })
          break
      }
    }
  }
}
</script>

<style>
</style>
